import React, { forwardRef } from "react";
import cx from "classnames";

import styles from "./Input.module.scss";

const Input = forwardRef((props, ref) => {
  const { className, inputClassName, testId, ...rest } = props;
  return (
    <input data-testid={testId} className={cx(styles.input, inputClassName)} ref={ref} {...rest} />
  );
});

export default Input;
